import {
  Alert,
  Container,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate } from 'react-router-dom';
import CreateJobForm from 'src/sections/job/CreateJobForm';
import { useMemo, useState } from 'react';
import { JobService } from 'src/api';

const CreateJob = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(null);
  const nav = useNavigate();

  useMemo(() => {
    if (data) {
      async function addJob() {
        try {
          setLoading(true);
          const result = await JobService.createJob(data);
          if (result.data?.successMessage) {
            nav('../jobs');
          } else {
            throw new Error('Unknown error occured');
          }
        } catch (error) {
          setError(error.message);
        } finally {
          setLoading(false);
          setData(null);
        }
      }
   
      addJob();
    }
  }, [data]);
  return (
    <>
      <Helmet>
        <title> Create Job | TGHrC</title>
      </Helmet>
      <Container>
        <Stack direction="row" alignItems="center" mb={5}>
          <Link to="../jobs">
            <IconButton aria-label="delete" size="medium">
              <ArrowBack fontSize="small" />
            </IconButton>
          </Link>
          <Typography variant="h4">Create Job</Typography>
        </Stack>
        {error && (
          <Alert variant="standard" severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
        <CreateJobForm
          loading={loading}
          onCreate={data => {
            setError(null);
            return setData(data);
          }}
        />
      </Container>
    </>
  );
};

export default CreateJob;
